import { Button } from '@/components/ui/button';
import {
  Card,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from '@/components/ui/card';
import keycloak from '@/lib/keycloak';
import { useAuth } from '@/contexts/auth-context';
import { useDocumentTitle } from '@/hooks/useDocumentTitle';

export function PendingApprovalPage() {
  useDocumentTitle('승인 대기 중');
  const { logout } = useAuth();

  const email = keycloak.tokenParsed?.email as string | undefined;
  const name = keycloak.tokenParsed?.name as string | undefined;

  const handleLogout = () => {
    logout();
  };

  return (
    <div
      className='min-h-screen flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8'
      style={{
        backgroundImage: 'url(/bg-login.png)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        backgroundColor: '#eeeefc',
      }}
    >
      <Card className='w-full max-w-md relative z-10 bg-white border-0 shadow-2xl'>
        <CardHeader className='space-y-1 flex flex-col items-center'>
          <div className='flex aspect-square size-12 items-center justify-center rounded-lg border-2 bg-white mb-4 shadow-lg'>
            <img src='/wjpnclogo.png' alt='WJPNC' width={48} height={48} />
          </div>
          <CardTitle className='text-2xl font-bold text-center'>
            계정 승인 대기 중
          </CardTitle>
          <CardDescription className='text-center'>
            관리자의 승인 후 서비스를 이용하실 수 있습니다.
          </CardDescription>
        </CardHeader>
        <CardContent className='space-y-2 text-center text-sm text-muted-foreground'>
          {name && <p className='font-medium text-foreground'>{name}</p>}
          {email && <p>{email}</p>}
        </CardContent>
        <CardFooter>
          <Button variant='outline' className='w-full' onClick={handleLogout}>
            로그아웃
          </Button>
        </CardFooter>
      </Card>
    </div>
  );
}
